import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../homeslider";
import PopularFlights from "../PopularFlights";

import AboutUs from "../AboutUs";
import Faqs from "../Faqs";
import Newsletter from "../Newsletter";
import PopularFlightsRoutes from "../PopularFlightsRoutes";
import PopularHotels from "../Hotels/Component/PopularHotels";
import BookTickets from "../BookTickets";
import FlightDestinations from "../FlightDestinations";
import PopularAirlines from "../PopularAirlines";
import FlightsFrom from "../FlightsFrom";
import FlightsWidgit from "../FlightsWidgit";
import CheapFlights from "../CheapFlights";
import Badge from "../Badge";

function App1() {
  return (
   <>

 <Helmet>
  <title>Flight Deals & Special Offers | Book Now at cheapflightsprices.com</title>
  <meta name="description" content="Grab the latest flight deals and discounted airfare offers at cheapflightsprices.com. Book now to save big on domestic and international travel." />
  <meta name="keywords" content="flight deals, travel offers, cheap flights, discounted tickets, limited time flight deals, international flight offers, domestic flight offers, cheapflightsprices" />
  
  <meta property="og:title" content="Flight Deals & Special Offers | Book Now at cheapflightsprices.com" />
  <meta property="og:description" content="Find exclusive airfare deals and cheap flight tickets with limited-time offers at cheapflightsprices.com. Book now and travel for less!" />
  <meta property="og:site_name" content="cheapflightsprices.com" />
  
  <meta name="twitter:title" content="Flight Deals & Special Offers | Book Today" />
  <meta name="twitter:description" content="Don't miss out on limited-time flight deals and travel discounts. Book cheap flights now at cheapflightsprices.com!" />
  
  <link rel="canonical" href="https://cheapflightsprices.com/deals" />
</Helmet>


   <section id="banner_section">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Flight Deals</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
      
    </div>
  </section>
<Badge/>


    <main id="main">
    <section id="Cheapflights" className="section-with-bg">
    <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2><strong>Flight Deals & Special Offers</strong></h2>
          <p></p>
        </div>
      <div className="deals-page">
  <p>Looking for the best flight deals? You've landed at the right place! At <strong>cheapflightsprices.com</strong>, we bring you unbeatable airfare deals on domestic and international travel. Whether you're planning a vacation, business trip, or last-minute escape — find the perfect flight without breaking the bank.</p>

  <h2>🔥 Trending Deals</h2>

  <h3>Domestic Deals Under ₹2,499</h3>
  <p>Fly to popular Indian cities like Delhi, Mumbai, Goa, and Bangalore at prices starting under ₹2,499. Limited seats available. Book fast before they're gone!</p>

  <h3>International Round-Trip Deals from ₹17,999</h3>
  <p>Explore destinations like Dubai, Bangkok, Singapore, and Maldives with budget-friendly round-trip fares starting at ₹17,999.</p>

  <h3>Last-Minute Deals</h3>
  <p>Need to travel urgently? Take advantage of our real-time last-minute flight deals that can save you big on unsold airline seats.</p>

  <h3>Student Flight Discounts</h3>
  <p>Special discounted fares for students traveling internationally. Book with valid student ID and enjoy extra baggage allowance too!</p>

  <h3>Festive Season Offers</h3>
  <p>Celebrate Diwali, Christmas, or New Year with exclusive holiday flight discounts. Travel during peak season at off-peak prices.</p>

  <h2>How to Grab the Best Deals</h2>

  <h3>Be Flexible with Dates</h3>
  <p>Airfares change daily. Adjust your travel dates and use flexible search filters to unlock the lowest prices.</p>

  <h3>Book in Advance</h3>
  <p>Most airlines release their cheapest seats early. Book 30–60 days in advance to lock in the best deals.</p>

  <h3>Subscribe for Deal Alerts</h3>
  <p>Sign up for our email newsletter and get notified instantly when new offers are available.</p>

  <h3>Use Price Comparison Tools</h3>
  <p>Our flight search engine compares prices from hundreds of airlines to bring you the cheapest fares in seconds.</p>

  <h2>Why Book with cheapflightsprices.com?</h2>

  <h3>✔ Transparent Pricing</h3>
  <p>No hidden charges. What you see is what you pay.</p>

  <h3>✔ Secure Bookings</h3>
  <p>Book your tickets with confidence using our encrypted and safe platform.</p>

  <h3>✔ 24/7 Customer Support</h3>
  <p>Our team is always ready to assist you — from booking to boarding.</p>

  <h2>Book Now & Save More</h2>
  <p>Whether you’re flying next week or next month, don’t miss out on today’s deals. Visit <strong>cheapflightsprices.com</strong> and start your journey with savings.</p>
</div>


      </div>
    </section>
    <PopularFlights/>
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <PopularHotels />
    <FlightsFrom/>

    <Faqs/>
    <Newsletter/>
    
      </main>
  
    </>
  );
}
export default App1;
